import produce, { castDraft, } from 'immer';
import { DeviceConfigSchemasActionType, } from '.';
const schemasByDeviceIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case DeviceConfigSchemasActionType.SET_DEVICE_CONFIG_SCHEMAS:
            return produce(currentState, (draft) => {
                const actualAction = action;
                draft[actualAction.deviceId] = castDraft(actualAction.schemas);
            });
        case DeviceConfigSchemasActionType.CLEAR_DEVICE_CONFIG_SCHEMAS:
            return produce(currentState, (draft) => {
                const actualAction = action;
                delete draft[actualAction.deviceId];
            });
        default:
            return currentState;
    }
};
export const deviceConfigSchemasStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.schemasByDeviceId = castDraft(schemasByDeviceIdReducer(currentState.schemasByDeviceId, action));
    });
};
